const quizTemplate = `<?xml version="1.0" encoding="UTF-8"?>
<quiz>
</quiz>`;

export default quizTemplate;
